document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('#product-grid li[data-product-url]');
  if (!items.length) return;

  items.forEach(function (li) {
    var url = li.getAttribute('data-product-url');
    if (!url) return;

    // Force canonical URL on title/detail links
    li.querySelectorAll('a.full-unstyled-link, a.product__view-details, a[href*="/products/collections-"]').forEach(function (a) {
      a.setAttribute('href', url);
    });

    // Make clicks on the card go to the canonical URL (ignore buttons/forms/quick-add)
    var cardInner = li.querySelector('.card__inner');
    if (cardInner) {
      cardInner.addEventListener('click', function (e) {
        if (e.target.closest('a, button, form, .quick-add')) return;
        window.location.href = url;
      }, { passive: true });
    }
  });
});
